import { MoneyInput } from '../MoneyInput.jsx';
import { InterestRateInput } from '../InterestRateInput.jsx';
import { RadioButtonGroup } from '../RadioButtonGroup.jsx';

export function LoanInput({
  inputKey,
  value,
  onChange,
  defaultType = null,
  defaultInterestRate = null,
}) {
  return (
    <div>
      <RadioButtonGroup
        componentKey={`LoanInput-${inputKey}`}
        label="Hvilken type gjeld er det?"
        buttons={[
          { key: 'consumer', value: 'Forbrukslån' },
          { key: 'credit_card', value: 'Kredittkort' },
        ]}
        onChange={type => onChange(value => ({ ...value, type }))}
        defaultKey={defaultType}
      />
      <InterestRateInput
        onChange={interestRate =>
          onChange(value => ({ ...value, interestRate }))
        }
        label="Hva er den effektive renten?"
        defaultValue={defaultInterestRate}
        startValue={15 * 100}
        required
      />
      <MoneyInput
        label="Hva er gjelden i dag?"
        onChange={loanAmount => onChange(value => ({ ...value, loanAmount }))}
        required
      />
    </div>
  );
}
